import React from 'react';

class ModalTerms extends React.PureComponent {
  render() {
    return (
      <div className="modal fade" id="modal-terms">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button aria-label="Close" className="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <h2>Souhlas s poskytnutím a zpracováním osobních údajů</h2>
              <p>
                Uděluji tímto dobrovolně svůj souhlas s poskytnutím a zpracováním osobních údajů
                dle Nařízení EU 679/2016 v rozsahu údajů obsažených v tomto formuláři, tj. zejména
                jméno, příjmení, e-mailová adresa a telefon správcem, tj. společností TAYLLORCOX s.r.o.
                se sídlem Na Florenci 1055/35, Nové Město, 110 00 Praha 1, Česká republika
                (dále jako „zpracovatel“).
              </p>
              <p>
                Svůj souhlas poskytuji pro účely zpracování akreditovaných kurzů, certifikací,
                elektronické komunikace, tj. poskytování informací elektronickou poštou či telefonicky,
                zasílání obchodních sdělení prostřednictvím elektronických prostředků dle zákona
                č. 480/2004 Sb., o některých službách informační společnosti, v platném znění.
              </p>
              <h2>Osobní údaje bude správce zpracovávat manuálně i automaticky.</h2>
              <p>
                Beru tímto na vědomí, že správce je na moji žádost povinen poskytnout mi informaci
                o zpracování mých osobních údajů, o jeho účelu, o osobních údajích, které jsou předmětem
                zpracování, včetně informací o jejich zdroji, povaze případného automatizovaného zpracování
                a o příjemcích osobních údajů, tedy o těch, komu byly mé osobní údaje zpřístupněny.
              </p>
              <p>
                Dále beru na vědomí, že mám právo požadovat po správci vysvětlení zpracování svých
                osobních údajů v případě, že bych zjistil nebo bych se domníval, že toto zpracování
                neprobíhá řádným způsobem, a dále právo požadovat po správci nápravu tohoto stavu
                spočívající zejm. v blokování, provedení opravy, doplnění nebo likvidaci osobních údajů.
              </p>
              <p>
                Svůj souhlas poskytuji dobrovolně a beru na vědomí, že mám právo jej kdykoliv odvolat.
                Tento souhlas uděluji na dobu 60 měsíců od jeho udělení.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalTerms;
